// @flow

import React, { type Element } from 'react'
import { Container, Typography } from '@material-ui/core'
import { styled } from '@material-ui/styles'
import Logo from '../../../../assets/images/banner/banner-logo-2022.png'
import BannerImage from '../../../../assets/images/banner/banner-image.png'

const BannerContainer = styled(Container)({
  minHeight: '110vh',
  height: '101%',
  background: '#EFEDE7',
  padding: '40px',
})

const BannerHeading = styled(Typography)({
  'font-family': 'Roboto',
  'font-style': 'normal',
  'font-weight': '500',
  'font-size': '32px',
  'line-height': '40px',
  color: '#333333',
  'margin-top': '88px',
})

const BannerPara = styled(Typography)({
  'font-family': 'Roboto',
  'font-style': 'normal',
  'font-weight': 'normal',
  'font-size': '16px',
  'line-height': '24px',
  color: '#333333',
  'margin-top': '16px',
  'margin-bottom': '40px',
  'max-width': '440px',
})

const ImageLogo = styled('img')({
  width: '96px',
  height: '32px',
})

const ImageBanner = styled('img')({
  maxWidth: '360px',
  maxHeight: '280px',
  width: '100%',
  height: '35%',
})

function Banner(): Element<typeof React.Fragment> {
  return (
    <BannerContainer>
      <a data-turbolinks="false" href="/">
        <ImageLogo src={Logo} alt="Dr. Bill Logo" />
      </a>
      <BannerHeading variant="h2" component="div">
        Welcome to Dr.Bill!
      </BannerHeading>
      <BannerPara variant="body2">
        We&#39;re excited to give you back some valuable free time—and help ensure you are paid
        accurately for the work that you do.
      </BannerPara>
      <ImageBanner src={BannerImage} alt="dashboard, new patient, new claim tabs" />
    </BannerContainer>
  )
}

export default Banner
